import { ComponentProps, ReactNode } from "react";
import BlurredPlaceholder from "@/app/(components)/generics/BlurredPlaceholder/BlurredPlaceholder";
import styles from "./AvatarDetailCard.module.css";

interface AvatarDetailCardProps {
  title: string;
  badge?: ReactNode;
  isPlaceholder?: boolean;
  placeholderConfig?: ComponentProps<typeof BlurredPlaceholder>["rows"];
  children: ReactNode;
}

export function AvatarDetailCard(props: AvatarDetailCardProps) {
  const { title, badge, isPlaceholder, placeholderConfig, children } = props;
  return (
    <div className={styles.detailCard}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        {badge && <div>{badge}</div>}
      </div>
      {isPlaceholder ? (
        <BlurredPlaceholder rows={placeholderConfig || [{ cells: [{ width: "100%" }] }]} />
      ) : (
        <div className={styles.item}>{children}</div>
      )}
    </div>
  );
}
